<template>
  <div class="supplier">
    <el-card>
      <z-search
        ref="search"
        v-model="params"
        :showNumCheck="false"
        :configs="searchConfigs"
        :isResetDoReloadData="false"
        @do-query="getListData(params)"
        @do-reset="getListData(params)"
      ></z-search>
    </el-card>
    <div class="content">
      <el-card>
        <div class="mb-16">
          <el-button @click="addNewSupplier" v-auth="'stores::supplier::add'" type="primary">
            {{ $t('supplier::add_button') }}
          </el-button>
        </div>
        <z-table
          v-loading="loading"
          ref="table"
          :data="list"
          :max-height="540"
          :columns="columns"
          :pagination.sync="pagination"
          @page-change="getListData"
        >
          <template #status="{ row }">
            <span v-if="row.status === 0">{{ editText.status_off }}</span>
            <span v-if="row.status === 1">{{ editText.status_on }}</span>
          </template>
          <template #options="{ row }">
            <el-button type="text" @click.stop="handleEdit(row)" v-auth="'stores::supplier::edit'">
              {{ editText.table_edit }}
            </el-button>
            <el-button type="text" @click.stop="handleDetail(row)" v-auth="'stores::supplier::detail'">
              {{ editText.table_detail }}
            </el-button>
            <el-button
              v-if="row.status === 0"
              v-auth="'stores::supplier::onOff'"
              type="text"
              @click.stop="handleOpen(row)"
            >
              {{ editText.status_on }}
            </el-button>
            <el-button
              v-if="row.status === 1"
              v-auth="'stores::supplier::onOff'"
              type="text"
              @click.stop="handleStop(row)"
            >
              {{ editText.status_off }}
            </el-button>
          </template>
        </z-table>
      </el-card>
    </div>
    <!-- 添加供应商弹窗 -->
    <!-- 编辑供应弹窗 -->
    <template v-if="addNewModal">
      <editDialog
        :id="modalId"
        :isNew="isNew"
        v-model="addNewModal"
        :formData="editModalForm"
        @getListData="getListData"
      ></editDialog>
    </template>
    <!-- 供应商详情弹窗 -->
    <el-dialog title="详情" :visible.sync="detailModal" width="600px" :close-on-click-modal="false">
      <el-form ref="detailModalForm" class="detailDialog" label-suffix="：" label-width="100px">
        <el-form-item prop="name" :label="$t('supplier::table_name')">
          {{ detailModalForm.name }}
        </el-form-item>
        <el-form-item prop="contacts" :label="$t('supplier::table_staff')">
          {{ detailModalForm.contacts }}
        </el-form-item>
        <el-form-item prop="phone" :label="$t('supplier::table_phone')">
          {{ detailModalForm.phone }}
        </el-form-item>
        <el-form-item prop="area" :label="$t('supplier::form_area')">
          {{ detailModalForm.province }}{{ detailModalForm.city }}{{ detailModalForm.area }}
        </el-form-item>
        <el-form-item prop="address" :label="$t('supplier::form_address')">
          {{ detailModalForm.address }}
        </el-form-item>
        <el-form-item prop="email" :label="$t('supplier::form_email')">
          {{ detailModalForm.email }}
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="detailModal = false">{{ $t('system::common::btn::close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postDataList, getSupplierStatus } from '@/server/supplier'
import editDialog from '../components/editDialog'

export default {
  name: 'Supplier',
  components: {
    editDialog
  },
  data() {
    return {
      editText: {
        status_off: this.$t('supplier::status_off'),
        status_on: this.$t('supplier::status_on'),
        table_edit: this.$t('supplier::table_edit'),
        table_detail: this.$t('supplier::table_detail')
      },
      modalId: '',
      isNew: false,
      loading: true,
      params: {
        supplierName: '',
        status: ''
      },
      searchConfigs: [
        {
          label: `${this.$t('supplier::name')}：`,
          key: 'supplierName',
          searchType: 'input',
          componentData: {
            placeholder: this.$t('supplier::placeholder_name')
          },
          clearable: true
        },
        {
          label: `${this.$t('supplier::status')}：`,
          key: 'status',
          searchType: 'select',
          componentData: {
            options: [
              { label: this.$t('supplier::status_all'), value: '' },
              { label: this.$t('supplier::status_off'), value: 0 },
              { label: this.$t('supplier::status_on'), value: 1 }
            ],
            placeholder: '全部状态',
            selectWidth: '80px'
          }
        }
      ],
      columns: [
        {
          prop: 'id',
          label: this.$t('supplier::table_no'),
          width: '120px',
          fixed: 'left',
          formatter: row => this.$dataCheck(row.id)
        },
        {
          prop: 'name',
          minWidth: '150px',
          label: this.$t('supplier::table_name'),
          showOverflowTooltip: true,
          fixed: 'left',
          formatter: row => this.$dataCheck(row.name)
        },
        {
          prop: 'contacts',
          minWidth: '150px',
          label: this.$t('supplier::table_staff'),
          formatter: row => this.$dataCheck(row.contacts)
        },
        {
          prop: 'phone',
          minWidth: '150px',
          label: this.$t('supplier::table_phone'),
          formatter: row => this.$dataCheck(row.phone)
        },
        {
          prop: 'status',
          minWidth: '100px',
          label: this.$t('supplier::table_status')
        },
        {
          prop: 'createTime',
          label: this.$t('supplier::table_createTime'),
          minWidth: '180px',
          formatter: row => this.$dataCheck(row.createTime)
        },
        {
          prop: 'options',
          label: this.$t('supplier::table_handle'),
          width: '210px',
          fixed: 'right'
        }
      ],
      list: [],
      pagination: {
        pageNum: 1, // 页码
        pageSize: 10, // 每页大小
        total: 0
      },
      // 弹窗数据
      addNewModal: false,
      editModal: false,
      editModalForm: {
        name: '',
        contacts: '',
        phone: '',
        address: '',
        email: '',
        province: '',
        city: '',
        area: ''
      },
      detailModal: false,
      detailModalForm: {
        name: '',
        contacts: '',
        phone: '',
        area: '',
        address: '',
        email: ''
      },
      stopModal: false
    }
  },
  methods: {
    // 获取供应商数据
    async getListData(list) {
      this.loading = true
      var obj = {
        page_num: this.pagination.pageNum,
        page_size: this.pagination.pageSize,
        supplier_name: list ? list.supplierName : '',
        status: list ? list.status : ''
      }
      const { data } = await postDataList(obj)
      if (data.code === 0) {
        this.loading = false
        this.list = data.data.items
        this.pagination.total = data.data.totalCount
      }
    },
    addNewSupplier() {
      for (let key in this.editModalForm) {
        this.editModalForm[key] = ''
      }
      this.isNew = true
      this.modalId = ''
      this.addNewModal = true
      this.$store.dispatch('buried', { event: 'StoreManagementClick', buttonName: '新增供应商' })
    },
    handleEdit(row) {
      this.editModalForm = {
        ...row,
        phone: Number(row.phone)
      }
      this.modalId = String(row.id)
      this.isNew = false
      this.addNewModal = true
    },
    handleDetail(row) {
      this.$router.push(`/supplier-detail/${row.id}`)
      // this.detailModal = true
      // this.detailModalForm = { ...row }
    },
    handleStop(row) {
      this.stopModal = true
      this.$confirm(
        `<p>${this.$t('supplier::name')}:${row.name}</p>
      <p>${this.$t('supplier::turn_off::tip')}</p>`,
        this.$t('supplier::turn_off::title'),
        {
          closeOnClickModal: false,
          showCancelButton: true,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.confirmStop(row)
        })
        .catch(() => {})
    },
    // 确认停用
    async confirmStop(row) {
      const { data } = await getSupplierStatus(row.id, 0, {})
      if (data.code === 0) {
        this.getListData()
        this.$message.success(this.$t('system::tip::close_success'))
        this.stopModal = false
      }
    },
    async handleOpen(row) {
      const { data } = await getSupplierStatus(row.id, 1, {})
      if (data.code === 0) {
        this.getListData()
        this.$message.success(this.$t('system::tip::open_success'))
      }
    }
  },
  mounted() {
    this.getListData()
  }
}
</script>

<style lang="scss" scoped>
.content {
  margin-top: 16px;
}
.detailDialog {
  /deep/.el-form-item {
    margin-bottom: 0;
  }
}
</style>
